export default function(instance) {
    return {
        getSearch() {
            return instance.get(`/api/v2/faq/search`)
        }
    }
}